const ExtinguisherIcon = ({ strokeColor = '#808080' }) => (
  <svg
    id="Layer_2"
    data-name="Layer 2"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 795.1 795.1"
  >
    <defs>
      <style>{`
        .cls-1 {
          fill: #fcfcfc; 
        }
        .cls-2 {
          fill: #4d4d4d;
        }
        .cls-3 {
          stroke: ${strokeColor}; 
          stroke-width: 50px;
        }
        .cls-3, .cls-4 {
          fill: none;
          stroke-miterlimit: 10;
        }
        .cls-4 {
          stroke: #fff; 
          stroke-width: 20px;
        }
        .cls-5 {
          fill: #fbfbfb; 
        }
      `}</style>
    </defs>

    <g id="Circles">
      <circle id="Grey_Bkg" className="cls-2" cx="397.55" cy="397.55" r="388.66" />
      <circle id="Grey" className="cls-3" cx="397.55" cy="397.55" r="372.55" />
      <circle id="White_Inner" className="cls-4" cx="397.55" cy="397.55" r="343.4" />
    </g>

    <g id="Shapes">
      <g id="Extinguisher">
        <path
          className="cls-5"
          d="M459.21,202.17c31.67,9.18,59.2,25.75,87.4,40.88,6.84,3.67,8.82,9.7,5.87,15.6-3.11,6.2-9.54,8.2-16.63,4.58-19.82-10.11-39.34-20.82-59.34-30.54-10.36-5.03-21.28-9.34-34.32-8.65,0,9.23-.81,18.15.45,26.77.43,2.92,5.72,6.38,9.38,7.36,12.85,3.42,24.28,9.11,33.86,18.27,17.75,16.97,24.92,39.59,21.45,67.13h-173.03c-3.42-34.42,7.13-61.89,38.45-78.71,7.15-3.84,15.43-5.95,23.45-7.66,6.31-1.34,8.94-3.87,8.46-10.39-.5-6.76.22-13.62-.49-20.35-.21-2.01-3.3-5.15-5.25-5.3-8.06-.61-15.76.34-22.98,5.33-3.34,2.31-8.77,1.85-13.28,2.16-5.54.38-11.42-.9-16.61.52-24.51,6.72-44.32,19.56-51.63,45.58-2.77,9.86-4.52,20.32-4.72,30.55-.5,26.38-.1,52.78.55,79.15.1,4.09,3.32,8.12,5.21,12.13,1.73,3.69,4.84,7.18,5.24,10.98,3.56,33.67,6.71,67.38,9.83,101.1.79,8.6-.89,10.22-9.39,10.24-16.73.04-33.45.03-50.18,0-8.12-.01-10.33-2.05-9.47-10.31,2.02-19.41,4.37-38.79,6.75-58.16,1.77-14.45,3.55-28.91,5.87-43.28.57-3.53,2.38-8.2,5.1-9.77,6.76-3.89,7.1-9.7,7.08-16.02-.1-27.44-.36-54.88-.36-82.31,0-21.56,5.49-41.61,18.39-59.08,14.88-20.15,36.77-28.58,59.9-34.85,3.36-.91,7.33-2.91,9.14-5.65,6.32-9.58,13.55-11.32,22.81-4.47,2.81,2.08,21.53,1.99,23.74-.44,1.08-1.19,1.67-3.25,1.66-4.91-.02-3.9-.69-7.78-.83-11.69-.18-5.27,1.91-9.96,7.45-10.18,35.18-1.36,70.38-2.46,105.59-3.23,6.99-.15,10.66,5,10.23,11.96-.43,6.92-4.4,10.14-12.9,10.29-18.28.31-36.56.54-54.83.88-4.59.08-9.66-.74-10.3,6.35-.63,7.1,5.32,5.65,8.84,7.34,1.12.54,2.51.52,4.41.83Z"
        />
        <path
          className="cls-5"
          d="M484.46,364.99h23.1v192.49h-173.1v-192.49h150.01Z"
        />
        <path
          className="cls-5"
          d="M371.66,630.58c-30.33-.32-38.65-11.83-37.61-51.55h173.9c0,8.15.5,16.45-.11,24.66-1.06,14.16-14.36,26.36-29.7,26.55-35.23.44-70.48.27-106.48.34Z"
        />
        <ellipse className="cls-5" cx="367.77" cy="212.24" rx="20.66" ry="21.53" />
      </g>
    </g>
  </svg>
);

export default ExtinguisherIcon;